import walletProductDetailDialogMessages from '../../../messages/wallet/wallet-product-detail-dialog.messages';
import { Column } from '../../column';
import { ProductTransaction } from '../details/product-transaction';

export const transactionsColumns: Column<ProductTransaction>[] = [
  {
    headerLabel:
      walletProductDetailDialogMessages.detailTransactionsOperationDate,
    key: 'operationDate',
    type: 'date',
  },
  {
    headerLabel:
      walletProductDetailDialogMessages.detailTransactionsSettlementDate,
    key: 'settlementDate',
    type: 'date',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailTransactionsValueDate,
    key: 'valueDate',
    type: 'date',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailTransactionsCategory,
    key: 'category',
    type: 'string',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailTransactionsReason,
    key: 'reason',
    type: 'string',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailTransactionsAmounts,
    key: 'amount',
    type: 'amount',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailTransactionsFees,
    key: 'fees',
    type: 'amount',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailTransactionsStamps,
    key: 'bolli',
    type: 'amount',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailTransactionsExpenses,
    key: 'expenses',
    type: 'amount',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailTransactionsEquivalent,
    key: 'equivalent',
    type: 'amount',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailTransactionsQuantity,
    key: 'quantity',
    type: 'number',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailTransactionsPrice,
    key: 'price',
    type: 'amount',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailTransactionsExchange,
    key: 'exchange',
    type: 'number',
  },
  {
    headerLabel:
      walletProductDetailDialogMessages.detailTransactionsPriceCurrency,
    key: 'priceCurrency',
    type: 'amount',
  },
  {
    headerLabel:
      walletProductDetailDialogMessages.detailTransactionsExchangeDate,
    key: 'exchangeDate',
    type: 'date',
  }
];
